import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import SearchBar from '../../publisher/rates/search-bar';

import LockIcon from '../../merchant/strategies/admin-lock.svg';
import EyeIcon from '../../merchant/strategies/public-eye.svg';
import BreadCrumbArrow from 'images/icons/breadcrumb-arrow.svg';

import './create-collection.scss';

const sections = ['Collection Details', 'Add Products', 'Availability'];

const CreateCollection = () => {
	const [loading, setLoading] = useState(true);
	const [name, setName] = useState('');
	const [description, setDescription] = useState('');
	const [searchTerm, setSearchTerm] = useState('');
	const [productQuery, setProductQuery] = useState('');
	const [products, setProducts] = useState(null);
	const [isPublic, setIsPublic] = useState(false);

	function getSection(idx) {
		let form;
		if (!idx) {
			form = (
				<div className="form">
					<div className="form-item">
						<label>Name</label>
						<input type="text"
							value={name}
							onChange={(e) => setName(e.target.value)}
							placeholder="Collection Name"
						/>
					</div>
					<div className="form-item">
						<label><p>Description</p>(optional)</label>
						<input type="text"
							className="description"
							value={description}
							onChange={(e) => setDescription(e.target.value)}
							placeholder="Collection Description"
						/>
					</div>
					<div className="form-item cover-image">
						<label>Cover Image</label>
						<div className="btn-container">
							<button className="upload-btn">Upload Image</button>
						</div>
					</div>
					<div className="form-item">
						<label>Connect to Campaign?</label>
						<input type="text" value="TODO" onChange={() => {}} />
					</div>
				</div>
			);
		} else if (idx === 1) {
			form = (
				<div className="form">
					<SearchBar
						setSearchQuery={setProductQuery}
						placeholder="Search for a Brand"
						searchTerm={searchTerm}
						setSearchTerm={setSearchTerm}
						loading={loading}
					/>
					<div className="products">
						{products && products.length ? products : 'No products added yet.'}
					</div>
				</div>
			);
		} else if (idx === 2) {
			form = (
				<div className="form">
					<div className={`radio-form-item ${isPublic ? 'selected' : ''}`}
						onClick={() => setIsPublic(true)}>
						<div className="input-label-icon">
							<span className="icon"><span className="fill"></span></span>
							<label>Public</label>
							<img src={EyeIcon} alt="eye" />
						</div>
						<p>
							If set to public, this campaign (draft or completed) will be visible to
							Publishers on the New Rates Page.
						</p>
					</div>
					<div className={`radio-form-item ${!isPublic ? 'selected' : ''}`}
						onClick={() => setIsPublic(false)}>
						<div className="input-label-icon">
							<span className="icon"><span className="fill"></span></span>
							<label>Admin Only</label>
							<img src={LockIcon} alt="lock" />
						</div>
						<p>
							This campaign (draft or completed) will only be visible to you and your internal team.
						</p>
					</div>
				</div>
			);
		}

		return (
			<div className={`section ${sections[idx].toLowerCase().split(' ').join('-')}`} key={idx}>
				<div className="name-icon">
					<span className="idx-icon">{idx + 1}</span>
					<h2>{sections[idx]}</h2>
				</div>
				{form}
			</div>
		);
	}

	return (
		<div className="create-collection-container">
			<div className="navigation">
				<Link to="/v2/admin/collections">Collections</Link>
				<img src={BreadCrumbArrow} alt="arrow" className="breadcrumb-arrow" />
				<span>Create Collection</span>
			</div>
			<h1>Create Collection</h1>
			<div className="section-names">
				{sections.map((section, idx) => (
					<div className="name-icon" key={idx}>
						<span className="idx-icon">{idx + 1}</span>
						<h2>{sections[idx]}</h2>
					</div>
				))}
			</div>
			<div className="sections">
				{sections.map((section, idx) => getSection(idx))}
			</div>
			<div className="controls">
				<button className="cancel">Cancel</button>
				<button className="save">Save Draft</button>
				<button className="create">Create Collection</button>
			</div>
		</div>
	);
};

export default CreateCollection;
